import { Search, X } from 'lucide-react';
import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

export interface CampoBuscaProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> {
  valor: string;
  aoMudar: (valor: string) => void;
  /** Nome acessível (fica escondido: a lupa e o placeholder já dizem o que é). */
  rotulo: string;
  /** Tecla que leva o foco ao campo, mostrada à direita (a página registra o atalho). */
  atalho?: string;
  /** Onde a busca procura (ex.: "em Nome, CNPJ"), em texto secundário ao lado do campo. */
  escopo?: ReactNode;
}

/** Campo de busca padrão (agents/skills/ui B.4): lupa, placeholder com o que se busca, botão de limpar e Esc limpa. */
export const CampoBusca = forwardRef<HTMLInputElement, CampoBuscaProps>(function CampoBusca(
  { valor, aoMudar, rotulo, atalho, escopo, className, onKeyDown, ...resto },
  ref,
) {
  return (
    <div className={className ? `campo-busca-grupo ${className}` : 'campo-busca-grupo'}>
      <label className="campo-busca">
        <Search size={15} strokeWidth={1.75} aria-hidden="true" className="campo-busca-lupa" />
        <span className="sr-only">{rotulo}</span>
        <input
          ref={ref}
          type="search"
          value={valor}
          onChange={(e) => aoMudar(e.target.value)}
          aria-keyshortcuts={atalho}
          onKeyDown={(e) => {
            if (e.key === 'Escape' && valor) {
              e.stopPropagation();
              aoMudar('');
            }
            onKeyDown?.(e);
          }}
          {...resto}
        />
        {valor ? (
          <button type="button" className="campo-busca-limpar" aria-label="Limpar busca" tabIndex={-1} onClick={() => aoMudar('')}>
            <X size={13} strokeWidth={2} aria-hidden="true" />
          </button>
        ) : atalho ? <kbd className="atalho" aria-hidden="true">{atalho}</kbd> : null}
      </label>
      {escopo && <span className="campo-busca-escopo">{escopo}</span>}
    </div>
  );
});
